import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Paper, ThemeProvider, Link } from '@mui/material';
import { CookieManager } from '../../../services/cookieManager';
import { darkTheme } from '../../../theme/darkTheme';
import { useNavigate } from 'react-router-dom';

const CookieBanner = () => {
    const [isVisible, setIsVisible] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        // Zeige das Banner an, wenn noch keine Entscheidung getroffen wurde
        if (CookieManager.needsConsent()) {
            setIsVisible(true);
        }
    }, []);

    const handleAcceptAll = () => {
        localStorage.setItem("kekseAbgelehnt", false);
        CookieManager.setConsentStatus('all');
        setIsVisible(false);
        // Optional: Hier könnten Analytics-Skripte initialisiert werden
        // initAnalytics();
    };

    const handleAcceptNecessary = () => {
        localStorage.setItem("kekseAbgelehnt", false);
        CookieManager.setConsentStatus('necessary');
        setIsVisible(false);
    };

    const handleDecline = () => {
        localStorage.setItem("kekseAbgelehnt", true);
        navigate("/");
    }

    if (!isVisible) return null;

    return (
        <ThemeProvider theme={darkTheme}>
            <Box
                sx={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    zIndex: 9999, // Sehr hoher z-index, damit es über allem liegt
                    p: { xs: 2, md: 3 },
                    display: 'flex',
                    justifyContent: 'center',
                    pointerEvents: 'none', // Box fängt keine Klicks ab
                }}
            >
                <Paper
                    elevation={24}
                    sx={{
                        pointerEvents: 'auto', // Paper fängt Klicks ab
                        maxWidth: '800px',
                        width: '100%',
                        p: 3,
                        borderRadius: '16px',
                        bgcolor: 'background.paper',
                        border: '1px solid rgba(59, 130, 246, 0.3)',
                        display: 'flex',
                        flexDirection: { xs: 'column', md: 'row' },
                        alignItems: { xs: 'flex-start', md: 'center' },
                        gap: 3,
                    }}
                >
                    <Box sx={{ flex: 1 }}>
                        <Typography variant="h6" sx={{ color: 'primary.main', fontWeight: 700, mb: 1 }}>
                            Wir verwenden Cookies
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.6 }}>
                            Diese App verwendet Cookies und LocalStorage. Einige davon sind essenziell (z.B. für den Login und das Speichern deines Themes), während andere uns in Zukunft helfen könnten, die App durch anonymisierte Analysen zu verbessern.
                            Weitere Informationen findest du in unserer{' '}
                            <Link href="/impressum" color="primary" underline="hover">Datenschutzerklärung</Link>.
                        </Typography>
                    </Box>

                    <Box sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        gap: 1.5,
                        width: { xs: '100%', md: 'auto' }
                    }}>
                        <Button
                            variant="outlined"
                            onClick={handleAcceptNecessary}
                            sx={{
                                fontWeight: 600,
                                borderRadius: '8px',
                                whiteSpace: 'nowrap',
                                borderColor: 'rgba(255,255,255,0.2)',
                                color: 'text.primary',
                                '&:hover': {
                                    borderColor: 'primary.main',
                                    bgcolor: 'rgba(59, 130, 246, 0.08)'
                                }
                            }}
                        >
                            Nur notwendige
                        </Button>
                        <Button
                            variant="outlined"
                            onClick={() => handleDecline()}
                            sx={{
                                fontWeight: 600,
                                borderRadius: '8px',
                                whiteSpace: 'nowrap',
                                borderColor: 'red',
                                color: 'text.primary',
                                '&:hover': {
                                    borderColor: 'primary.main',
                                    bgcolor: 'rgba(59, 130, 246, 0.08)'
                                }
                            }}
                        >
                            Ablehnen
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleAcceptAll}
                            sx={{
                                fontWeight: 700,
                                borderRadius: '8px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Alle akzeptieren
                        </Button>
                    </Box>
                </Paper>
            </Box>
        </ThemeProvider>
    );
};

export default CookieBanner;
